/** Список промокодов по рассрочки Тинькофф */
export enum InstallmentPlanTinkoff {
    /**
     * 3 месяца
     * 0-0-3 со скидкой 4.5%
     */
    Installment00345,
    /**
     * 6 месяца
     * 0-0-6 со скидкой 7.7% 
     */
    Installment00677,
    /**
     * 9 месяца
     * 0-0-9 со скидкой 10.7% 
     */
    Installment009107,
    /**
     * 10 месяца
     * 0-0-10 со скидкой 11.7% 
     */
    Installment0010117,
    /**
     * 12 месяца
     * 0-0-12 со скидкой 13.5% 
     */
    Installment0012135,
    /**
     * 15 месяца
     * 0-0-15 со скидкой 16.5% 
     */
    Installment0015165,
    /**
     * 18 месяца
     * 0-0-18 со скидкой 19% 
     */
    Installment001819,
    /**
     * 24 месяца
     * 0-0-24 со скидкой 24% 
     */
    Installment002424,
    /**
     * 30 месяца
     * 0-0-30 со скидкой 28.5% 
     */
    Installment0030285,
    /**
     * 36 месяца
     * 0-0-36 со скидкой 32.5% 
     */
    Installment0036325,
    /**
     * 4 месяца
     * 0-0-4 со скидкой 5.5%
     */
    Installment00455
}